import { render, staticRenderFns } from "./Texto.vue?vue&type=template&id=6284a04e&scoped=true&lang=pug&"
import script from "./Texto.vue?vue&type=script&lang=js&"
export * from "./Texto.vue?vue&type=script&lang=js&"
import style0 from "./Texto.styl?vue&type=style&index=0&id=6284a04e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6284a04e",
  null
  
)

export default component.exports